import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "w-panel w-branch-picker",
  "aria-label": "Выбор филиала"
}
const _hoisted_2 = { class: "w-small" }
const _hoisted_3 = { class: "w-branch-options" }
const _hoisted_4 = ["onClick"]

import { useScheduleStore } from '@/store/calendar/scheduleModule';


export default /*@__PURE__*/_defineComponent({
  __name: 'BranchPicker',
  setup(__props) {

const store = useScheduleStore();

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("h2", null, "Выберите филиал", -1)),
    _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(store).actorDoctor?.name) + " · доступно филиалов: " + _toDisplayString(_unref(store).branchOptions.length), 1),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).branchOptions, (branch) => {
        return (_openBlock(), _createElementBlock("button", {
          key: branch.id,
          class: "w-button",
          type: "button",
          onClick: ($event: any) => (_unref(store).setBranch(branch.id))
        }, [
          _createVNode(_component_q_icon, { name: "apartment" }),
          _createTextVNode(" " + _toDisplayString(branch.name), 1)
        ], 8, _hoisted_4))
      }), 128))
    ])
  ]))
}
}

})